/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const InvoiceManagement: React.FC<Props> = ({ color = '#000000', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <path
        d="M5 8C5 5.17157 5 3.75736 5.87868 2.87868C6.75736 2 8.17157 2 11 2H13C15.8284 2 17.2426 2 18.1213 2.87868C19 3.75736 19 5.17157 19 8V16C19 18.8284 19 20.2426 18.1213 21.1213C17.2426 22 15.8284 22 13 22H11C8.17157 22 6.75736 22 5.87868 21.1213C5 20.2426 5 18.8284 5 16V8Z"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
      />
      <path
        d="M5 4.07617C4.02491 4.17208 3.36857 4.38885 2.87868 4.87873C2 5.75741 2 7.17163 2 10.0001V14.0001C2 16.8285 2 18.2427 2.87868 19.1214C3.36857 19.6113 4.02491 19.828 5 19.9239"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
      />
      <path
        d="M19 4.07617C19.9751 4.17208 20.6314 4.38885 21.1213 4.87873C22 5.75741 22 7.17163 22 10.0001V14.0001C22 16.8285 22 18.2427 21.1213 19.1214C20.6314 19.6113 19.9751 19.828 19 19.9239"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
      />
      <path
        d="M9 13H15"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 9H15"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 17H12"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default InvoiceManagement;
